import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { updateSize } from '../actions/shipback'

import PackageSize from './PackageSize'


class ReturnSize extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.setSize = this.setSize.bind(this);
  }

  setSize(size){
    this.props.updateSize(size, shipback_id, this.props.user_token)
  }

  render() {
    return (
      <div>
        <h2>{I18n.t('shipbacks.items.dimensions.title')} </h2>
        <div className="row dimensions">
          { this.props.sizes.map((dimension) => (
            <PackageSize key={dimension.label} dimension={dimension} size={this.props.size} selectSize={this.setSize} />
          ))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  size: state.shipback.size,
  user_token: state.user,
  sizes: state.sizes
})

const mapDispatchToProps = dispatch => bindActionCreators({ updateSize }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReturnSize)


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnSize.jsx